import { Link } from 'react-router-dom';

import { useMachines } from '../../features/machines/api/useMachines';

export function MachineSwitcher({ machineId }: { machineId: string }) {
  const machines = useMachines();
  const current = machines.data?.machines.find((machine) => machine.id === machineId);

  return (
    <div className="dropdown r42-machine-switcher">
      <button
        className="r42-machine-switcher__button"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        aria-label={`Current machine: ${current?.name ?? 'Loading machine'}`}
      >
        <span className="r42-machine-switcher__selection">
          <strong>{current?.name ?? 'Loading machine…'}</strong>
          <i className="bi bi-chevron-down" aria-hidden="true" />
        </span>
      </button>
      <ul className="dropdown-menu dropdown-menu-end r42-machine-menu">
        {machines.data?.machines.map((machine) => (
          <li key={machine.id}>
            <Link className={`dropdown-item${machine.id === machineId ? ' active' : ''}`} to={`/machines/${machine.id}`}>
              <strong>{machine.name}</strong>
              <small>{machine.assetId ?? machine.location ?? 'Machine workspace'}</small>
            </Link>
          </li>
        ))}
        <li><hr className="dropdown-divider" /></li>
        <li><Link className="dropdown-item" to="/machines">View all machines</Link></li>
      </ul>
    </div>
  );
}
